import { Disclosure, Transition } from "@headlessui/react";
import { ChevronDownIcon, ChevronRightIcon } from "@heroicons/react/20/solid";
import { Link, useLocation } from "react-router-dom";
import routes from "../../shared/routes";

import sellnshiplogo from "../../sellnshiplogo.png";
import { useState } from "react";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export default function SideNavigationBar(props) {
  const { business, outsideClickRef, userType } = props;

  const [isMinimized, setIsMinimized] = useState(false);

  const location = useLocation();
  const getRoutes = routes(location.pathname, userType);
  const routesArray = getRoutes["routes"];

  return (
    <div
      className="layout-sidebar hide-for-print rounded-2xl bg-white border-r border-gray-100"
      ref={outsideClickRef}
    >
      {/* Navigation Header */}
      <div className="flex grow flex-col gap-y-6 overflow-y-auto pb-4">
        {/* Brand Section */}
        <div className="flex h-20 shrink-0 items-center border-b border-gray-100 pl-4 pr-6">
          <div className="flex items-center space-x-4">
            <div className="flex h-9 w-9 items-center justify-center rounded-lg bg-brand-500">
              <span className="text-xl font-bold text-white">
                {business.name?.charAt(0) || 'F'}
              </span>
            </div>
            <div className={isMinimized ? "hidden" : "flex flex-col"}>
              <p className="text-xl font-bold text-brand-500 uppercase tracking-wide">
                {business.name}
              </p>
            </div>
          </div>
        </div>

        {/* Navigation Menu */}
        <nav className="flex flex-1 flex-col layout-menu-container">
          <ul className="flex flex-1 flex-col space-y-1">
            {routesArray.map((item) => (
              <li key={item.name}>
                {!item.children ? (
                  <Link
                    to={item.href}
                    className={classNames(
                      item.current
                        ? "font-bold text-black"
                        : "text-black hover:bg-gray-50 transition-all duration-200 group",
                      "flex items-center pl-4 pr-6 py-3 text-sm leading-6 relative"
                    )}
                  >
                    <item.icon
                      className="h-5 w-5 shrink-0 text-brand-500"
                      aria-hidden="true"
                    />
                    <span className={classNames(
                      isMinimized ? "hidden" : "",
                      "flex-1 truncate ml-4"
                    )}>
                      {item.name}
                    </span>
                  </Link>
                ) : (
                  <Disclosure
                    as="div"
                    defaultOpen={item.open}
                    className="sidebar-parent-div"
                  >
                    {({ open }) => (
                      <>
                        <Disclosure.Button
                          className={classNames(
                            item.current
                              ? "font-bold text-black"
                              : "text-black hover:bg-gray-50 transition-all duration-200 group",
                            "flex items-center w-full text-left pl-4 pr-6 py-3 text-sm leading-6 relative"
                          )}
                          onClick={() => setIsMinimized(false)}
                        >
                          <item.icon
                            className="h-5 w-5 shrink-0 text-brand-500"
                            aria-hidden="true"
                          />
                          <span className={classNames(
                            isMinimized ? "hidden" : "",
                            "flex-1 truncate text-left ml-4"
                          )}>
                            {item.name}
                          </span>
                          <div className={classNames(
                            isMinimized ? "hidden" : "",
                            "ml-2 flex items-center"
                          )}>
                            {open ? (
                              <ChevronDownIcon
                                className="h-4 w-4 shrink-0 text-black transition-transform duration-200"
                                aria-hidden="true"
                              />
                            ) : (
                              <ChevronRightIcon
                                className="h-4 w-4 shrink-0 text-black transition-transform duration-200"
                                aria-hidden="true"
                              />
                            )}
                          </div>
                        </Disclosure.Button>
                        <Transition
                          enter="transition-all duration-300 ease-out"
                          enterFrom="opacity-0 max-h-0 transform scale-95"
                          enterTo="opacity-100 max-h-96 transform scale-100"
                          leave="transition-all duration-200 ease-in"
                          leaveFrom="opacity-100 max-h-96 transform scale-100"
                          leaveTo="opacity-0 max-h-0 transform scale-95"
                        >
                          <Disclosure.Panel as="ul" className="mt-1 space-y-1">
                            {item.children.map((subItem) => (
                              <li key={subItem.name}>
                                <Link
                                  to={subItem.href}
                                  className={classNames(
                                    subItem.current
                                      ? "font-bold text-black"
                                      : "text-black hover:bg-gray-50 transition-all duration-200",
                                    "block py-2.5 pl-8 pr-6 text-sm leading-6 relative"
                                  )}
                                >
                                  <span className="block truncate">{subItem.name}</span>
                                </Link>
                              </li>
                            ))}
                          </Disclosure.Panel>
                        </Transition>
                      </>
                    )}
                  </Disclosure>
                )}
              </li>
            ))}
          </ul>
        </nav>
      </div>
    </div>
  );
}
